// extracted by mini-css-extract-plugin
export default {"container":"uD-z","innerContainer":"vD-z","multipleLines":"wD-z","heading":"xD-z","content":"yD-z","linkColor":"zD-z"};